<template>
  <div class="inputPattern">
    <van-field
      v-model="checkList[index].value"
      :placeholder="checkList[index].placeHolder"
      :error-message="checkList[index].msg"
      :type="checkList[index].type"
      :disabled="disabled"
      @blur="checkRule(checkList,index)"
      @click="action"
      @input="change"
    />
  </div>
</template>

<script>
export default {
  name: 'InputPattern',
  components: {},
  props: {
    checkList: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default() { return false }
    }
  },
  data() {
    return {
      obj: {

      }
    }
  },
  watch: {
    obj: {
      handler(newval, oldval) {
        if (Object.keys(oldval).length !== 0) {
          this.checkRule(this.checkList, this.index)
        }
      },
      deep: true
    }
  },
  created() {
    this.obj = this.checkList[this.index]
  },
  methods: {
    checkRule(inf, index) {
      if (inf[index].rule.test(inf[index].value)) {
        inf[index].msg = ''
        inf[index].state = true
      } else {
        inf[index].msg = inf[index].des
        inf[index].state = false
      }
    },
    action() {
      this.$emit('click')
    },
    change() {
      this.$emit('change')
    }
  }
}
</script>

<style scoped lang='scss'>
</style>
